<template>
  <v-layout column>

    <input id="trackUrl" style="position: absolute; left: -1000px; top: -1000px" />

    <v-flex xs12>
      <h4>Booking Additional</h4>
    </v-flex>
    <v-flex xs12>
      <table class="addtable" style="font-size: 11px;">
        <tr>
          <th>ID</th>
          <th>AMOUNT</th>
          <th>STATE</th>
          <th>ACTION</th>
        </tr>
        <tr v-for="request in bookingForm.booking.additionalChargeRequests">
          <td>{{request.id}}</td>
          <td>{{(request.amount / 100).toFixed(2)}}</td>
          <td v-html="request.chargesSummary"></td>
          <td>{{request.state}}</td>
          <td v-if="request.state == 'pending'"><v-btn @click="cancel(request)" x-small>Cancel</v-btn></td>
          <td v-if="request.state == 'pending'"><v-btn @click="copyLink(request)" x-small>Copy Link</v-btn></td>
          <td v-if="request.state == 'completed' || request.state == 'refunded'"><v-btn @click="showRefund(request)" x-small>Refund</v-btn></td>
        </tr>
      </table>
      <v-layout pt-1 row>
        <v-flex xs6>
          <v-layout style="width: 100%" column>
            <v-btn
            @click="addDialog" x-small>Add</v-btn>
             </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
       <v-dialog persistent v-model="addAdditionalChargeDialog" :width="800">
        <v-card v-if="bookingForm.booking != null">
          <v-card-title primary-title class="headline grey lighten-1">
            <v-layout align-center justify-center>
              <span
                class="title font-weight-light white--text"
                style="line-height: 18pt !important"
              >
                Create Additional For Booking:
                <b>{{ bookingForm.booking.id }}</b>
              </span>
            </v-layout>
          </v-card-title>
            <v-flex pa-3>
            <v-select
              v-model="selectedPropertyAdditionalChargesItems"
              item-value="id"
              :items="propertyAdditionalCharges"
              outlined
              label="Booking Properties"
              dense
              :height="28"
              hide-details
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <span>{{ item.name }},&nbsp;</span>
              </template>
              <template v-slot:item="{ item, index }">
                <span>{{ item.name }}</span>
              </template>
            </v-select>
            </v-flex>
            <v-flex pa-3>
            <v-select
              v-model="selectedLocationAdditionalChargesItems"
              item-value="id"
              :items="locationAdditionalCharges"
              outlined
              label="Location Properties"
              dense
              :height="28"
              hide-details
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <span>{{ item.name }},&nbsp;</span>
              </template>
              <template v-slot:item="{ item, index }">
                <span>{{ item.name }}</span>
              </template>
            </v-select>
            </v-flex>
            <v-flex pa-3>
              £{{total}}
            </v-flex>
          <v-card-actions v-if="!loading && result == null">
            <v-layout row justify-end>
              <v-btn small color="red darken-1" flat @click="addAdditionalChargeDialog = false"
                >Cancel</v-btn
              >
              <v-flex pl-2><v-btn small color="green darken-1" flat @click="create"
                >Create</v-btn
              ></v-flex>
            </v-layout>
          </v-card-actions>
          <v-card-actions v-if="loading">
            <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear>
          </v-card-actions>
             <v-card-actions v-if="!loading && result != null">
            <v-layout row justify-end>
              <v-flex>{{result}}</v-flex>
              <v-flex pl-2><v-btn small color="green darken-1" flat @click="addAdditionalChargeDialog = false"
                >Done</v-btn
              ></v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
       <v-dialog persistent v-model="refundDialog" :width="800">
        <v-card v-if="chargeToRefund != null">
          <v-card-title primary-title class="headline grey lighten-1">
            <v-layout align-center justify-center>
              <span
                class="title font-weight-light white--text"
                style="line-height: 18pt !important"
              >
                Refund Additional For Additional:
                <b>{{ chargeToRefund.id }}</b>
              </span>
            </v-layout>
          </v-card-title>
          <v-card-actions v-if="!loading && refundResult == null">
           <div><p>£{{(refundableAmount/100).toFixed(2)}}</p>
           <v-currency-field
              type="number"
              v-bind="currency_config"
              v-model="refundAmount"
              min="0"
              class="small-text-field"
              single-line
              height="28"
              flat
            ></v-currency-field></div>
          </v-card-actions>
          <v-card-actions v-if="!loading && refundResult == null">
            <v-layout row justify-end>
              <v-btn small color="red darken-1" flat @click="refundDialog = false"
                >Cancel</v-btn
              >
              <v-flex pl-2><v-btn small color="green darken-1" flat @click="refund"
                >Create</v-btn
              ></v-flex>
            </v-layout>
          </v-card-actions>
          <v-card-actions v-if="loading">
            <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear>
          </v-card-actions>
          <v-card-actions v-if="!loading && refundResult != null">
            <v-layout row justify-end>
              <v-flex>{{refundResult}}</v-flex>
                <v-flex pl-2>
                <v-btn small color="green darken-1" flat @click="refundDialog = false">Done</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-layout>
</template>

<script>
import moment from "moment";

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "booking_additional_summary",
  props: {
    bookingForm: Object
  },
  data: function() {
    return {
      addAdditionalChargeDialog: false,
      locationAdditionalCharges: [],
      propertyAdditionalCharges: [],
      selectedPropertyAdditionalChargesItems: [],
      selectedLocationAdditionalChargesItems: [],
      loading: false,
      result: null,
      refundableAmount: null,
      refundAmount: 0,
      chargeToRefund: null,
      refundResult: null,
      refundDialog: false,
      refundAmount: 0,
      currency_config: {
        decimal: ".",
        prefix: "£",
        precision: 2,
        masked: false,
        allowBlank: true
      },
    };
  },
  mounted: function() {
    this.getAdditionals();
  },
  computed: {
    total: function() {
      var total = 0;

      for (var i = 0; i < this.locationAdditionalCharges.length; i++) {
        if (this.selectedLocationAdditionalChargesItems.indexOf(this.locationAdditionalCharges[i].id) != -1) {
          total += this.locationAdditionalCharges[i].amount;
        }
      }

      for (var i = 0; i < this.propertyAdditionalCharges.length; i++) {
        if (this.selectedPropertyAdditionalChargesItems.indexOf(this.propertyAdditionalCharges[i].id) != -1) {
          total += this.propertyAdditionalCharges[i].amount;
        }
      }

      return (total / 100).toFixed(2);
    }
  },
  methods: {
    copyLink: function(charge) {
      const el = document.getElementById("trackUrl");
      el.value = charge.url;
      el.select();
      document.execCommand("copy");

      navigator.clipboard.writeText(charge.url)

      console.log("Copied " + el.value);
    }, 
    showRefund: async function(charge) {
      this.refundableAmount = 0;
      this.refundDialog = true;
      this.chargeToRefund = charge;
      this.refundResult = null;
      this.refundAmount = 0;
      this.loading = true;

      try {
          var url = `${this.$store.state.apiUrl}/booking_additional_charge/getRefundableAmount?token=${this.chargeToRefund.token}`;

          let response = await axios.get(url, {
            params: {}
          });

          if (response.data.error == 'no_error') {
            this.refundableAmount = response.data.amount
          } else {
            alert(response.data.error);
          }
          
          this.loading = false;

      } catch (error) {
          this.loading = false;
          console.log(error);
          console.log("Failed to get");
      }
    },
    cancel: async function(additionalCharge) {

        try {
          var url = `${this.$store.state.apiUrl}/booking_additional_charge/cancel?token=${additionalCharge.token}`;

          let response = await axios.post(url, {
            params: {}
          });

          if (response.data.error == 'no_error') {
            additionalCharge.state = 'cancelled'
          } else {
            alert(response.data.error);
          }

        } catch (error) {
          this.loading = false;
          console.log(error);
          console.log("Failed to get");
        }

    },
    refund: async function() {

      this.loading = true;

        try {
          var url = `${this.$store.state.apiUrl}/booking_additional_charge/refund?token=${this.chargeToRefund.token}&amount=${Math.round(this.refundAmount * 100)}`;

          let response = await axios.post(url, {
            params: {}
          });

          if (response.data.error == 'no_error') {
            this.chargeToRefund.state = 'refunded'
            this.refundResult = "Success"
          } else {
            this.refundResult = response.data.error;
          }

          this.loading = false;

        } catch (error) {
          this.loading = false;
          console.log(error);
          console.log("Failed to get");
        }

    },
    addDialog: function() {
      this.addAdditionalChargeDialog = true;
      this.result = null;
    },
    create: async function() {

       console.log("Create");

       if (this.total <= 0) {
         return;
       }

       this.loading = true;

       try {
          var url = `${this.$store.state.apiUrl}/booking_additional_charge/create?bookingId=${this.bookingForm.booking.id}`;

          for (var i = 0; i < this.selectedLocationAdditionalChargesItems.length; i++) {
            url+= `&locationAdditionalCharges=${this.selectedLocationAdditionalChargesItems[i]}`
          }

          for (var i = 0; i < this.selectedPropertyAdditionalChargesItems.length; i++) {
            url+= `&propertyAdditionalCharges=${this.selectedPropertyAdditionalChargesItems[i]}`
          }

          let response = await axios.post(url, {
            params: {}
          });

          if (response.data.error == 'no_error') {
            if (response.data.booking_additional_charge_request.state == 'completed') {
              this.result = "Charge Captured Succesfully"
            } else { 
              this.result = "Payment Request is pending as no card associated with booking."
            }

            this.bookingForm.booking.additionalChargeRequests.push(response.data.booking_additional_charge_request);
          }

        } catch (error) {
          this.loading = false;
          console.log(error);
          console.log("Failed to get");
        }

        this.loading = false;
    },
    getAdditionals: async function() {

      console.log("Get Additionals");

       try {
          var url = `${this.$store.state.apiUrl}/booking_additional_charge/allCandidateCharges`;

          let response = await axios.get(url, {
            params: {}
          });

          this.locationAdditionalCharges = response.data.location_additional_charges;
          this.propertyAdditionalCharges = response.data.property_additional_charges;
        } catch (error) {
          this.loading = false;
          console.log(error);
          console.log("Failed to get");
        }
    }
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

tr:nth-child(even) {background: #dadada}
tr:nth-child(odd) {background: #FFF}
</style>
